import styled from 'styled-components';

export const Wrapper = styled.div`
  font-size: 14px;
  border-right: 1px solid light-dark(var(--mantine-color-dark-3), var(--mantine-color-dark-4));
  height: calc(100vh - 62px);
`;

export const Content = styled.div`
  overflow-y: auto;
  display: flex;
  height: calc(100vh - 120px);
`;

export const Bottom = styled.div`
  padding: 3px 10px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
`;
